import {
    AppBar as MuiAppBar,
    AppBarProps as MuiAppBarProps,
    Avatar as MuiAvatar,
    IconButton,
    styled,
    Toolbar,
    Typography
} from "@mui/material";
import { Stack } from "@mui/system";
import { UserProfile } from "../../../contexts/authorize.context";

const AvatarStyled = styled(MuiAvatar)(({ theme }) => ({
    width: 35,
    height: 35,
}));

const AppBarWrapped = styled(MuiAppBar)<MuiAppBarProps>(({ theme }) => ({
    left: theme.custom.left.appBar,
    width: theme.custom.width.appBar,
}));

type AppBarProps = {
    userProfile: UserProfile;
};
const AppBar = ({ userProfile }: AppBarProps) => {
    return (
        <AppBarWrapped color="transparent" elevation={0}>
            <Toolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}></Typography>
                <Stack
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        color="inherit"
                    >
                        <AvatarStyled src={userProfile?.photo} />
                    </IconButton>
                    <Stack>
                        <Typography>{userProfile?.fullName}</Typography>
                        <Typography variant="caption">{userProfile?.email}</Typography>
                    </Stack>
                </Stack>
            </Toolbar>
        </AppBarWrapped>
    );
};

export default AppBar;
